import { http } from "@/utils/http";
export const utms = (params) => {
  // 预约表单提交
  return http({
    url: `/1/utms/`,
    method: "post",
    data: params,
  });
};
export const send = (params) => {
  // 发送验证码
  return http({
    url: `/1/utms/send/`,
    method: "post",
    data: params,
  });
};
export const check = (params) => {
  // 检查验证码
  return http({
    url: `/1/utms/check/`,
    method: "post",
    data: params,
  });
};
export const ip = (params) => {
  // 检查验证码
  return http({
    url: `/1/utms/ip/`,
    method: "post",
    data: params,
  });
};
export const guidances = () => {
  // 获取指南
  return http({
    url: `/1/guidances/`,
    method: "get",
    params: {
      page: 1,
      limit: 999,
    },
  });
};
export const guidancesDetail = (id) => {
  // 获取指南详情
  return http({
    url: `/1/guidances/${id}`,
    method: "get",
  });
};

export const appointmentAction = (params) => {
  // 预约表单提交
  return http({
    url: `/1/reservation/`,
    method: "post",
    data: params,
  });
};